// Turns the certificate <div> into a PNG, then downloads it or shares it.
// Needs:  npm install html2canvas
import { message } from 'antd';

const toBlob = async (node) => {
  const { default: html2canvas } = await import('html2canvas');
  const canvas = await html2canvas(node, { scale: 2, backgroundColor: null, useCORS: true });
  return new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 1));
};

const fileName = (title) => `lincfolio-${String(title).toLowerCase().replace(/[^a-z0-9]+/g, '-')}.png`;

const saveBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const downloadAchievement = async (node, title) => {
  try {
    const blob = await toBlob(node);
    if (!blob) throw new Error('no image');
    saveBlob(blob, fileName(title));
    message.success('Achievement saved!');
  } catch (e) {
    console.error(e);
    message.error('Unable to save image.');
  }
};

export const shareAchievement = async (node, title) => {
  try {
    const blob = await toBlob(node);
    if (!blob) throw new Error('no image');
    const file = new File([blob], fileName(title), { type: 'image/png' });

    // phones and some browsers can share the image directly
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: `Lincfolio – ${title}`,
        text: `I unlocked "${title}" on Lincfolio!`,
      });
      return;
    }

    // desktop fallback: save the image so it can be posted anywhere
    saveBlob(blob, fileName(title));
    message.info('Sharing is not supported here, so the image was downloaded instead.');
  } catch (e) {
    if (e && e.name === 'AbortError') return; // user closed the share sheet
    console.error(e);
    message.error('Unable to share achievement.');
  }
};